import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

export const TaleModal = ({ children, className = "" }) => {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    setOpacity(1);
  }, []);

  return ReactDOM.createPortal(
    <div
      style={{
        opacity,
      }}
      className={`fixed transition-all top-0 left-0 w-full h-full backdrop-blur-sm z-50 ${
        className ?? ""
      }`}
    >
      {children}
    </div>,
    document.body
  );
};